(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4059],{

/***/ 91331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ products_section; }
});

// UNUSED EXPORTS: ProductsSectionForTest

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/components/sections/products-section/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.25rem;\n  line-height: 1.875rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledNeedsCTA = (0,styled_components_browser_esm["default"])(ahm_ui/* SpacerWrapper */.Cj).withConfig({
    componentId: "sc-49455ddf-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/utils/customer-has-changed/index.ts
var customer_has_changed = __webpack_require__(51552);
// EXTERNAL MODULE: ./src/client/utils/get-future-date/index.tsx
var get_future_date = __webpack_require__(84701);
// EXTERNAL MODULE: ./src/client/components/needs-product-data-loader/index.ts + 1 modules
var needs_product_data_loader = __webpack_require__(4035);
// EXTERNAL MODULE: ./src/client/components/premium-review-toggle-wrapper/index.tsx + 2 modules
var premium_review_toggle_wrapper = __webpack_require__(12224);
// EXTERNAL MODULE: ./src/client/components/price-disclaimer/index.tsx + 2 modules
var price_disclaimer = __webpack_require__(76383);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/index.tsx + 7 modules
var pricing_drawer = __webpack_require__(87022);
// EXTERNAL MODULE: ./src/client/pages/product-listing/product-listing-common.ts
var product_listing_common = __webpack_require__(77484);
;// CONCATENATED MODULE: ./src/client/components/sections/products-section/components/product-tiles/activity-indicator/index.tsx



var Dot = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-661374e7-0"
})(function(param) {
    var isActive = param.isActive, theme = param.theme;
    return "\n  width: 0.75rem;\n  height: 0.75rem;\n  margin-right: 0.5rem;\n  border-radius: 50%;\n  display: inline-block;\n  background-color: ".concat(theme.colors[isActive ? "grey20" : "grey10"], ";\n");
});
var ActivityIndicator = function(param) {
    var pageCount = param.pageCount, currentPage = param.currentPage;
    var dots = [];
    for(var i = 1; i <= pageCount; i += 1){
        var isActive = currentPage === i;
        dots.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
            isActive: isActive,
            "aria-current": isActive
        }, i));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "group",
        "aria-label": "Viewing page ".concat(currentPage, " of ").concat(pageCount),
        children: dots
    });
};
/* harmony default export */ var activity_indicator = (ActivityIndicator);

// EXTERNAL MODULE: ./src/client/utils/browser.ts
var browser = __webpack_require__(40055);
// EXTERNAL MODULE: ./src/client/utils/prepare-products-for-product-tiles/index.ts
var prepare_products_for_product_tiles = __webpack_require__(95327);
// EXTERNAL MODULE: ./src/client/components/sections/products-section/components/product-tiles/styles.module.sass
var styles_module = __webpack_require__(93553);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
;// CONCATENATED MODULE: ./src/client/components/sections/products-section/components/product-tiles/update-tile-pagination/index.ts


var forEachWithIndex = (0,uncap_fp_iterator/* default */.Z)(fp.forEach);
var updateTilePagination = function(element, tilePagination, setTilePagination) {
    var tileContainerRect = element.getBoundingClientRect();
    var tiles = element.children;
    forEachWithIndex(function(currentTile, index) {
        var tileRect = currentTile.getBoundingClientRect();
        var isTileInViewport = tileRect.left >= tileContainerRect.left && tileRect.right <= tileContainerRect.right;
        if (isTileInViewport) {
            // @ts-expect-error - Automatic, Please fix when editing this file
            var firstTileRect = tiles[0].getBoundingClientRect();
            // tileWidth does not include the margin between tiles, to accurately calculate the tile width we need to get the margin between tiles, this matters because we need to know how many tiles can fit within the tileContainer to calculate the pageCount otherwise we could see a tile count of `3 of 2` instead of `3 of 3` when the window is resized whilst using css scroll-snap-align.
            // @ts-expect-error - Automatic, Please fix when editing this file
            var tileMargin = Math.abs(firstTileRect.right - tiles[1].getBoundingClientRect().left);
            var pageCount = Math.ceil(tiles.length / Math.floor(tileContainerRect.width / (firstTileRect.width + tileMargin)));
            var newTilePagination = {
                currentPage: index + 1,
                pageCount: pageCount
            };
            // don't re-render the component if nothing has changed
            if ((0,fp.isEqual)(newTilePagination, tilePagination)) {
                return false;
            }
            setTilePagination(newTilePagination);
            return false;
        }
        return true;
    }, tiles);
};
/* harmony default export */ var update_tile_pagination = (updateTilePagination);

;// CONCATENATED MODULE: ./src/client/components/sections/products-section/components/product-tiles/index.tsx



function product_tiles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 1.5rem;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  scroll-snap-type: x mandatory;\n\n  & > div {\n    margin-right: 1rem;\n  }\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    product_tiles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  scroll-snap-align: center;\n  width: 16rem;\n\n  @media (min-width: ",
        ") {\n    width: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var ADVANCED_HOSPITAL_GOLD_EXCESS_750 = ahm_constants/* default.PRODUCT.ADVANCED_HOSPITAL_GOLD_EXCESS_750 */.Z.PRODUCT.ADVANCED_HOSPITAL_GOLD_EXCESS_750;
var GOLD_HOSPITAL_PRODUCT_IDS = [
    ADVANCED_HOSPITAL_GOLD_EXCESS_750
];
// @ts-expect-error - Automatic, Please fix when editing this file
var getProductTileProps = function(isLoadingPrice, product, blurb) {
    var additionalDetails = product.additionalDetails, ctaText = product.ctaText, id = product.id, url = product.url;
    return {
        additionalDetails: additionalDetails,
        blurb: blurb,
        ctaText: ctaText,
        id: id,
        isLoadingPrice: isLoadingPrice,
        key: id,
        linkTo: url,
        variant: (styles_module_default()).productTile
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getProductBlurb = function(product) {
    return (0,fp.includes)(product.id, GOLD_HOSPITAL_PRODUCT_IDS) ? "All the gold category hospital services including pregnancy and birth." : (0,fp.get)("content.longForm", product);
};
var HorizontalScrollWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-6051b246-0"
})(product_tiles_templateObject());
var HorizontalScrollProductTile = (0,styled_components_browser_esm["default"])(ahm_ui/* ProductTile */.vB).withConfig({
    componentId: "sc-6051b246-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var ProductTiles = function(param) {
    var isLoadingPrice = param.isLoadingPrice, products = param.products, customer = param.customer, prices = param.prices, useFutureEffectiveDate = param.useFutureEffectiveDate, withHorizontalScroll = param.withHorizontalScroll;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(null), tilePagination = ref1[0], setTilePagination = ref1[1];
    // @ts-expect-error - Automatic, Please fix when editing this file
    (0,react.useEffect)(function() {
        var tileContainer = ref.current;
        if (!tileContainer) {
            return false;
        }
        if (!tilePagination) {
            // @ts-expect-error - Automatic, Please fix when editing this file
            update_tile_pagination(tileContainer, tilePagination, setTilePagination);
        }
        var debouncedUpdateTilePagination = (0,fp.debounce)(150, function() {
            // @ts-expect-error - Automatic, Please fix when editing this file
            update_tile_pagination(tileContainer, tilePagination, setTilePagination);
        });
        // @ts-expect-error - Automatic, Please fix when editing this file
        tileContainer.addEventListener("scroll", debouncedUpdateTilePagination);
        browser/* default.getWindow */.Z.getWindow().addEventListener("resize", debouncedUpdateTilePagination);
        return function() {
            // @ts-expect-error - Automatic, Please fix when editing this file
            tileContainer.removeEventListener("scroll", debouncedUpdateTilePagination);
            browser/* default.getWindow */.Z.getWindow().removeEventListener("resize", debouncedUpdateTilePagination);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // we don't need deps as we only need to attach the event listeners on first render, and remove on unmount
    return withHorizontalScroll ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
        variant: "marginBottomSpacer6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalScrollWrapper, {
                ref: ref,
                children: (0,fp.map)(function(product) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalScrollProductTile, (0,_object_spread/* default */.Z)({}, (0,fp.omit)([
                        "url",
                        "content"
                    ], product), getProductTileProps(isLoadingPrice, product, getProductBlurb(product))));
                }, (0,prepare_products_for_product_tiles/* default */.Z)(products, customer, prices, useFutureEffectiveDate))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                df: true,
                lg: true,
                children: tilePagination && /*#__PURE__*/ (0,jsx_runtime.jsx)(activity_indicator, (0,_object_spread/* default */.Z)({}, tilePagination))
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
        variant: "marginBottomSpacer6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* AxisSwitcher */.e$, {
            limit: 3,
            space: "1rem",
            threshold: "40rem",
            children: (0,fp.map)(function(product) {
                return(// @ts-expect-error - Automatic, Please fix when editing this file
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).productTileWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* ProductTile */.vB, (0,_object_spread/* default */.Z)({}, (0,fp.omit)([
                        "url",
                        "content"
                    ], product), getProductTileProps(isLoadingPrice, product, getProductBlurb(product))))
                }, product.url));
            }, (0,prepare_products_for_product_tiles/* default */.Z)(products, customer, prices, useFutureEffectiveDate))
        })
    });
};
ProductTiles.defaultProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product_listing_common/* default.defaultProps */.Z.defaultProps), {
    isLoadingPrice: false,
    withHorizontalScroll: false
});
/* harmony default export */ var product_tiles = (ProductTiles);

// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
// EXTERNAL MODULE: ./src/client/selectors/select-needs-product-type/index.ts
var select_needs_product_type = __webpack_require__(82488);
// EXTERNAL MODULE: ./src/client/selectors/select-needs-type/index.ts
var select_needs_type = __webpack_require__(69286);
// EXTERNAL MODULE: ./src/client/components/sections/products-section/styles.module.sass
var products_section_styles_module = __webpack_require__(51620);
var products_section_styles_module_default = /*#__PURE__*/__webpack_require__.n(products_section_styles_module);
// EXTERNAL MODULE: ./src/client/components/sections/wrapped-section/index.tsx
var wrapped_section = __webpack_require__(51878);
;// CONCATENATED MODULE: ./src/client/components/sections/products-section/index.tsx

























var ProductsSection = function(param) {
    var actions = param.actions, compareButtonText = param.compareButtonText, compareButtonToLink = param.compareButtonToLink, customer = param.customer, data = param.data, image = param.image, isLoadingPrice = param.isLoadingPrice, prices = param.prices, products = param.products, useFutureEffectiveDate = param.useFutureEffectiveDate, withBorder = param.withBorder, withDrawer = param.withDrawer, withHorizontalScroll = param.withHorizontalScroll, withNeedsLink = param.withNeedsLink, withVerticalSpacing = param.withVerticalSpacing;
    var productIds = (0,fp.map)("id", products);
    var productIdsHaveChanged = (0,fp.join)("|", productIds);
    var customerHasChanged = (0,customer_has_changed/* default */.Z)(customer, useFutureEffectiveDate);
    var subtitle = (0,fp.get)("subtitle", data);
    var title = (0,fp.get)("title", data);
    var hasHeaderDetails = !(0,fp.isNull)(image) || !(0,fp.isEmpty)(title) || !(0,fp.isEmpty)(subtitle);
    (0,react.useEffect)(function() {
        // This component is only used on pages where only 750 excess is sold
        // @ts-expect-error - Automatic, Please fix when editing this file
        actions.customer.changeHospitalExcess("750");
        // @ts-expect-error - Automatic, Please fix when editing this file
        actions.price.load(productIds, customer, {
            date: (0,get_future_date/* default */.Z)(useFutureEffectiveDate)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        customerHasChanged,
        productIdsHaveChanged,
        useFutureEffectiveDate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(wrapped_section/* default */.Z, {
        withBorder: withBorder,
        spacerSize: withVerticalSpacing ? 3 : 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                variant: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((0,_define_property/* default */.Z)({}, (products_section_styles_module_default()).verticalSpacingWrapper, withVerticalSpacing)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((products_section_styles_module_default()).horizontalSpacingWrapper, (products_section_styles_module_default()).spacingWrapper),
                        children: [
                            hasHeaderDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
                                variant: "marginBottomSpacer6",
                                children: [
                                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                        alt: image.alt,
                                        src: image.src,
                                        className: (products_section_styles_module_default()).image
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                        children: title
                                    }),
                                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                                        xs: true,
                                        sm: true,
                                        children: subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_review_toggle_wrapper/* default */.ZP, {
                                type: "alternativePage",
                                showBackground: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(product_tiles, {
                                customer: customer,
                                isLoadingPrice: isLoadingPrice,
                                prices: prices,
                                products: products,
                                useFutureEffectiveDate: useFutureEffectiveDate,
                                withHorizontalScroll: withHorizontalScroll
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                                // @ts-expect-error - Automatic, Please fix when editing this file
                                className: classnames_default()((0,_define_property/* default */.Z)({}, (products_section_styles_module_default()).withNeedsLink, withNeedsLink)),
                                to: compareButtonToLink,
                                variant: [
                                    (products_section_styles_module_default()).compareButton,
                                    "border",
                                    "white"
                                ],
                                children: compareButtonText
                            }),
                            withNeedsLink && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNeedsCTA, {
                                variant: "marginBottomSpacer8",
                                children: [
                                    "Not sure what you need?",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                        to: ahm_constants/* default.URLS.SALES.FIND_HEALTH_INSURANCE */.Z.URLS.SALES.FIND_HEALTH_INSURANCE,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                                            children: "Tailor your health cover"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(price_disclaimer/* default */.ZP, {
                                    bold: true,
                                    showRefineLink: true,
                                    highlightIncome: true,
                                    forProducts: products,
                                    center: true
                                })
                            })
                        ]
                    })
                })
            }),
            withDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_drawer/* default */.Z, {
                isProductWithHospitalServices: true,
                showIncomeOptions: true
            })
        ]
    });
};
ProductsSection.defaultProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product_listing_common/* default.defaultProps */.Z.defaultProps), {
    data: null,
    image: null,
    isLoadingPrice: false,
    withBorder: false,
    withDrawer: true,
    withHorizontalScroll: false,
    withNeedsLink: false,
    withVerticalSpacing: true
});
// @ts-expect-error - Automatic, Please fix when editing this file
var mapStateToProps = function(state, props) {
    return {
        customer: (0,select_customer/* default */.Z)(state),
        isLoadingPrice: state.price.loading,
        needsProductType: (0,select_needs_product_type/* default */.Z)(state, props),
        needsType: (0,select_needs_type/* default */.Z)(state, props),
        prices: state.price.data,
        useFutureEffectiveDate: state.price.useFutureEffectiveDate
    };
};
/* harmony default export */ var products_section = ((0,redux/* compose */.qC)(needs_product_data_loader/* default */.Z, (0,es/* connect */.$j)(mapStateToProps, product_listing_common/* default.mapDispatchToProps */.Z.mapDispatchToProps))(ProductsSection));



/***/ }),

/***/ 59794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export serviceMapper */
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_future_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84701);
/* harmony import */ var _is_product_best_seller__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(591);
/* harmony import */ var _models_price__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2798);
/* harmony import */ var _models_url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26789);





// @ts-expect-error - Automatic, Please fix when editing this file
var serviceMapper = function(feature) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(param) {
        var id = param.id, name = param.name;
        return {
            id: id,
            name: name
        };
    }, feature.services);
};
var prepareProductForProductTile = function(param) {
    var customer = param.customer, frequency = param.frequency, prices = param.prices, mlsAmount = param.mlsAmount, useFutureEffectiveDate = param.useFutureEffectiveDate;
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    function(product) {
        if (!product) {
            return null;
        }
        var id = product.id, additionalDetails = product.additionalDetails, charges = product.charges, content = product.content, ctaText = product.ctaText, extras = product.extras, features = product.features, hospital = product.hospital, hospitalTier = product.hospitalTier, name = product.name, rank = product.rank, type = product.type, ctaProductId = product.ctaProductId, parentProductId = product.parentProductId, unavailableWithExcessInfo = product.unavailableWithExcessInfo;
        var scale = customer.scale;
        var date = (0,_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(useFutureEffectiveDate);
        var price = _models_price__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getPrice */ .Z.getPrice(prices, id, customer, {
            date: date
        });
        var priceObject = price ? _models_price__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getAmountAsObject */ .Z.getAmountAsObject(price, frequency) : undefined;
        var saving = mlsAmount && priceObject ? Math.max(mlsAmount - parseFloat("".concat(priceObject.dollars, ".").concat(priceObject.cents)), 0) : undefined;
        var hospitalFeatured = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)([], "hospital.featured", product);
        var hospitalServices = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flatMap)(serviceMapper, hospitalFeatured);
        return {
            additionalDetails: additionalDetails,
            charges: charges,
            content: content,
            ctaText: ctaText,
            extras: extras,
            features: features,
            frequency: frequency,
            hospital: hospital,
            hospitalTier: hospitalTier,
            id: id,
            isAvailable: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(scale, product.scales.supported),
            isBestSeller: (0,_is_product_best_seller__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                parentProductId: parentProductId,
                productId: id,
                productType: type,
                scale: scale
            }),
            name: name,
            price: priceObject,
            rank: rank,
            saving: saving,
            scale: customer.scale,
            services: hospitalServices,
            type: type,
            unavailableWithExcessInfo: unavailableWithExcessInfo,
            url: _models_url__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getProductUrl */ .Z.getProductUrl(ctaProductId || id)
        };
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (prepareProductForProductTile);



/***/ }),

/***/ 95327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _prepare_product_for_product_tile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59794);


var prepareProductsForProductTiles = function(allProducts, customer, prices, useFutureEffectiveDate) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)((0,_prepare_product_for_product_tile__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        customer: customer,
        frequency: customer.frequency,
        mlsAmount: undefined,
        prices: prices,
        useFutureEffectiveDate: useFutureEffectiveDate
    }), allProducts);
};
/* harmony default export */ __webpack_exports__["Z"] = (prepareProductsForProductTiles);


/***/ }),

/***/ 85500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X5": function() { return /* binding */ scrollTo; },
/* harmony export */   "kI": function() { return /* binding */ scrollToElement; },
/* harmony export */   "wA": function() { return /* binding */ getScrollPosition; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_is_server__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41105);


// Due to Firefox / Chrome following different standards. https://miketaylr.com/posts/2014/11/document-body-scrollTop.html
function getScrollPosition() {
    return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
}
function scrollTo() {
    var to = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var isServer = (0,_get_is_server__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    if (isServer) {
        return;
    }
    window.scrollTo({
        behavior: "smooth",
        top: to
    });
    // this is used for `back to top` button after being clicked, return tab order to where it has id `backToTopPoint`
    var backToTopPoint = document.getElementById("backToTopPoint");
    if (backToTopPoint) {
        backToTopPoint.focus({
            preventScroll: true
        });
    }
}
function scrollToElement(element) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNull)(element)) {
        return;
    }
    var scrollPosition = element.getBoundingClientRect().top + getScrollPosition() + offset;
    scrollTo(scrollPosition);
}


/***/ }),

/***/ 93553:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","productTile":"styles_productTile__CCG_3","productTileWrapper":"styles_productTileWrapper__b87M1"};

/***/ }),

/***/ 51620:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","verticalSpacingWrapper":"styles_verticalSpacingWrapper__9RHpm","spacingWrapper":"styles_spacingWrapper__QbnA2","compareButton":"styles_compareButton__sFI_S","withNeedsLink":"styles_withNeedsLink__FG5ZX","horizontalSpacingWrapper":"styles_horizontalSpacingWrapper__7UgID","image":"styles_image__ylwTS"};

/***/ })

}]);